import forEach from 'lodash/forEach'

export function parallelLimit<R>(
  tasks: Array<() => Promise<R>>,
  limit: number
): Promise<{
  results: Array<R>
  errors: Array<unknown>
}> {
  return new Promise(resolve => {
    let cursorAt = 0
    let numCompletedTasks = 0

    const results: Array<R> = []
    const errors: Array<unknown> = []

    function addTasksToQueue(numTasksToAdd: number) {
      if (tasks.length > numCompletedTasks) {
        forEach(tasks.slice(cursorAt, cursorAt + numTasksToAdd), process)
        cursorAt += numTasksToAdd
      } else {
        resolve({
          results,
          errors
        })
      }
    }

    function process(task: () => Promise<R>) {
      task()
        .then(result => {
          results.push(result)
          numCompletedTasks += 1
          addTasksToQueue(1)
        })
        .catch(error => {
          errors.push(error)
          numCompletedTasks += 1
          addTasksToQueue(1)
        })
    }

    addTasksToQueue(tasks.length > limit ? limit : tasks.length)
  })
}
